import { sendHttpRequest } from './api';
import { HTTP_REQUEST_TYPE, HTTP_RESPONSE_TYPE, ALERT_MODULE_API } from '../constants/api';
import { FilterAndSortOptions } from '../slices/alertModuleSlice';

const getAlertsList = async (params: FilterAndSortOptions) => {
    const [err, resp] = await sendHttpRequest(HTTP_REQUEST_TYPE.post, ALERT_MODULE_API.getAlertsList, params);
    if (err) {
        return [err];
    }

    const { status, data } = resp;
    if (status === HTTP_RESPONSE_TYPE.success) {
        return [null, data];
    }
};

export { getAlertsList };
